import { cn } from "@/lib/utils";

import BackgroundColorPicker from "@/components/widget/editor/toolbar-buttons/background-color-picker";
import BackgroundImagePicker from "@/components/widget/editor/toolbar-buttons/background-image-picker";
import BorderColorPicker from "@/components/widget/editor/toolbar-buttons/background-border-picker";
import BorderStylePicker from "@/components/widget/editor/toolbar-buttons/background-border-raduce-picker";

interface Props extends React.ComponentProps<"div"> {
  editorRef: React.RefObject<HTMLDivElement>;
}

const DesignTab: React.FC<Props> = ({ editorRef, className, ...props }) => {
  return (
    <div className={cn("flex items-center gap-x-3", className)} {...props}>
      <BackgroundImagePicker editorRef={editorRef} />
      <BackgroundColorPicker editorRef={editorRef} />
      <BorderColorPicker editorRef={editorRef} />
      <BorderStylePicker editorRef={editorRef} />
    </div>
  );
};
export default DesignTab;
